import type { AdDesignData } from '@jobilla/nexus-sdk'
import { atom } from 'jotai'
import type { DesignGalleryMode } from './types'

export const designGalleryOpenAtom = atom(false)
export const designGalleryModeAtom = atom<DesignGalleryMode>('picker')

/**
 * Holds the resolve/reject pair for the current open() promise.
 * When a design is selected, resolve is called. When closed without selection, resolve(undefined).
 * If a second caller opens while a previous promise is pending, the previous is rejected.
 */
export const designGalleryPromiseAtom = atom<
	{
		resolve: (value: AdDesignData | undefined) => void
		reject: (reason?: unknown) => void
	} | null
>(null)
